import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

import { CustomerCard } from "components/StatsCard/CustomerCard.jsx";
import EditProfile from "./EditProfile";
import AddNewAddress from "./AddNewAddress";
import NewOrder from "../CustomerOrders/NewOrder";
import { connect } from "react-redux";
import { HashRouter, Route } from "react-router-dom";
import { Redirect } from "react-router";
import { selectCustomer } from "../../redux/actions";
import OrderList from "../CustomerOrders/OrderList";
import SingleOrder from "../CustomerOrders/SingleOrder";
import { Alert } from "react-bootstrap";

const mapStateToProps = (state) => {
  return {
    isEditProfile: state.customerInfo.isEditProfile,
    selectedCustomer: state.selectedCustomer,
    customers: state.customers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectCustomer: (customer) => {
      dispatch(selectCustomer(customer));
    },
  };
};

class CustomerInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canVisitPage: false,
    };
    this.checkForChangingToCustomerRoute =
      this.checkForChangingToCustomerRoute.bind(this);
    this.findCustomerByCall = this.findCustomerByCall.bind(this);
    this.renderIsBlocked = this.renderIsBlocked.bind(this);
  }

  findCustomerByCall(call) {
    if (call != undefined) {
      let selectedC = undefined;
      this.props.customers.map((customer) => {
        if (customer.call == call) {
          selectedC = customer;
          this.props.selectCustomer(customer);
        }
      });
      if (selectedC) return selectedC;
      else return undefined;
    } else return undefined;
  }

  componentWillMount() {
    let call = this.props.match.params.call;
    if (call != undefined) {
      let user = this.findCustomerByCall(call);
      if (user != undefined) this.setState({ canVisitPage: true });
      else this.checkForChangingToCustomerRoute();
    } else {
      this.checkForChangingToCustomerRoute();
    }
  }

  checkForChangingToCustomerRoute() {
    if (
      this.props.selectedCustomer == undefined ||
      this.props.selectedCustomer == {}
    ) {
      this.setState({ canVisitPage: false });
    } else {
      this.setState({ canVisitPage: true });
    }
  }

  renderIsBlocked() {
    if (this.props.selectedCustomer?.isBlocked) {
      return (
        <Alert bsStyle="danger">
          <span style={{ fontSize: 16 }}>
            <b>این مشتری در لیست سیاه می باشد</b>
          </span>
        </Alert>
      );
    }
  }

  render() {
    if (!this.state.canVisitPage) {
      return <Redirect to={"/customers"} />;
    }
    return (
      <div className="content">
        <HashRouter>
          <Grid fluid>
            <Row>
              <Col lg={12} sm={12} md={12}>
                {this.renderIsBlocked()}
              </Col>
              <Col lg={3} sm={6}>
                <CustomerCard
                  route={"/neworder"}
                  icon={<i className="pe-7s-box1 icon4" />}
                  name="سفارش جدید"
                />
              </Col>
              <Col lg={3} sm={6}>
                <CustomerCard
                  route={"/orders"}
                  icon={<i className="pe-7s-folder icon3" />}
                  name="سفارشات"
                />
              </Col>

              <Col lg={3} sm={6}>
                <CustomerCard
                  changeStateOfEdit={true}
                  route={"/editprofile"}
                  icon={<i className="pe-7s-pen icon2" />}
                  name="ویرایش اطلاعات"
                />
              </Col>

              <Col lg={3} sm={6}>
                <CustomerCard
                  changeStateOfEdit={false}
                  route={"/newaddress"}
                  icon={<i className="pe-7s-map-2 icon1" />}
                  name="آدرس‌ها"
                />
              </Col>
            </Row>
            <Route path="/editprofile" component={EditProfile} />
            <Route path="/newaddress" component={AddNewAddress} />
            <Route path="/neworder" component={NewOrder} />
            <Route path="/orders" component={OrderList} />
            <Route path="/singleorder" component={SingleOrder} />
          </Grid>
        </HashRouter>
      </div>
    );
  }
}

const CustomerConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerInfo);

export default CustomerConnect;
